import { httpRequest } from '../request';

import type {
  ProductsFilterRequestData,
  ProductsListRequestData,
  ProductsSearchRequestData,
} from '../types/product';
import type { httpRequestConfig } from '../types/request';

export default {
  list: (data: ProductsListRequestData, config: httpRequestConfig = {}) =>
    httpRequest('POST:/api/products/list', { data }, config),
  filter: (data: ProductsFilterRequestData) =>
    httpRequest('GET:/api/products/params', { params: data }),
  search: (data: ProductsSearchRequestData) =>
    httpRequest('GET:/api/products/search', { params: data }),
};
